import { css } from "@emotion/react";

import { colors } from "@dotnet/telematics-design-system";

import { svgFontSize } from "shared/styles/styleFunctions";

import { IconProps } from "./types";

const Icon = ({ icon, iconColor, iconColorCustom, isDisabled }: IconProps) => {
    const getColor = () => {
        if (isDisabled) return colors.textDisabled;

        return iconColorCustom ?? iconColor;
    };

    return (
        <span
            css={css({
                display: "inline-flex",

                "& > svg": {
                    color: getColor(),
                    ...svgFontSize(16)
                }
            })}
        >
            {icon}
        </span>
    );
};

export default Icon;
